export default __webpack_public_path__ + "static/media/video5.ca3d9330.mp4";